/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AsyncJob } from '../models/AsyncJob';
import type { AsyncJobStatus } from '../models/AsyncJobStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AsyncJobService {

    /**
     * get list of async jobs
     * @returns AsyncJob Success
     * @throws ApiError
     */
    public static getAsyncJobList({
        status,
        ignorePagination,
        limit,
        offset,
    }: {
        /**
         * Async Job status
         */
        status?: Array<AsyncJobStatus>,
        /**
         * Ignore pagination to fetch all records
         */
        ignorePagination?: boolean,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<Array<AsyncJob>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/asyncJob',
            query: {
                'status': status,
                'ignorePagination': ignorePagination,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
